module.exports = __webpack_public_path__ + "static/media/VENTLESS.d4d16aa0.svg";